import React from 'react'
import PropTypes from 'prop-types'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { en } from 'make-plural/plurals'

import LocalisationContext from './LocalisationContext'

const defaultLocale = 'en';

i18n.loadLocaleData({
  en: { plurals: en }
})

let messagesInitialised = false

export function initialiseTestingMessages(messages) {
  i18n.load({
    en: messages
  })
  i18n.activate('en')
  messagesInitialised = true
}

const TestingLocalisationProvider = ({ children }) => {
  if (!messagesInitialised) {
    throw new Error('WARNING: You need to call initialiseTestingMessages(messages) once before using the <TestingLocalisationProvider />.')
  }

  const context = {
    defaultLocale,
    locale: defaultLocale,
    changeLocale: () => {
      console.warn('Can not change locale during test')
    }
  }
  return (
    <LocalisationContext.Provider value={context}>
      <I18nProvider i18n={i18n}>
        {children}
      </I18nProvider>
    </LocalisationContext.Provider>
  )
}

TestingLocalisationProvider.defaultProps = {
  children: null
}

TestingLocalisationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ])
}

export default TestingLocalisationProvider
